import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

export class AbstractFormControl implements OnDestroy {
  protected destroyed: Subject<void> = new Subject();

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.unsubscribe();
  }
}
